export const GET_CODE_ITEMS_LIST = "GET_CODE_ITEMS_LIST";

//Cpde comparison
export const GET_CODE_DIFFERENCES_LIST = "GET_CODE_DIFFERENCES_LIST";